module.exports = __webpack_public_path__ + "static/black2-94c0e574b770c37149742c10f9f0774b.png";